import { Box, Stack } from "@mui/system";
import { Typography } from "@mui/material";
import {
  spacing,
  typography,
} from "../../../../../../../../../../assets/styles/tokens";
import DailyEarningsGapsCard from "./DailyEarningsGapsCard";

const DailyEarningsGapsItem = ({
  sortedData = [],
}: {
  sortedData?: Record<string, any>[];
}) => {
  if (!sortedData?.length) {
    return (
      <Box sx={{ mt: spacing.Spacing.xl.$value, textAlign: "center" }}>
        <Typography sx={{ fontSize: typography.Size.Text.sm.$value }}>
          No data found
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: "-" + spacing.Spacing.md.$value }}>
      <Stack spacing={2}>
        {sortedData.map((item, index) => (
          <DailyEarningsGapsCard key={item.brand_id ?? index} row={item} />
        ))}
      </Stack>
    </Box>
  );
};

export default DailyEarningsGapsItem;
